import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-video',
  standalone: true,
  imports: [CommonModule],
  styles: [`
    .ok-btn {
      background-color: #635ca8;
      color: #fff;
      padding: 7px 30px;
      border-radius: 20px;
    }

    .close-icon{
      position: absolute;
      right: 10px;
      top: 10px;
      border: 1px solid #ddd;
      border-radius: 50px;
      padding: 5px;
      background-color: white;
    }

    ::ng-deep .cdk-overlay-pane {
      aspect-ratio: 16 / 9;
    }

    ::ng-deep .aspect_ratio{
      @media(max-width: 768px){
        width: 100% !important;
      }
    }
  `],
  template: `
    <div class="h-100 overflow-hidden">
      <a class="close-icon" href="javascript:void(0)" (click)="close()">
        <img width="20px" src="assets/icons/close-icon.svg" alt="" />
      </a>
      <iframe
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/zuLaaHgVXR0?si=RAZDGjQo6zvhauoS"
        title="Welcome to Glamera"
        frameborder="0"
        allow="accelerometer; autoplay;  encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  `,
})
export class VideoComponent {
  constructor(private dialogRef: MatDialogRef<VideoComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
